import Icon from "@mui/icons-material/ViewAgendaTwoTone";
import List from "./list";
import Edit from "./edit";
import Create from "./create";

export default {
  list: List,
  edit: Edit,
  create: Create,
  icon: Icon,
  label: "Agenda",
  options: { label: "Agenda" },
  name: "agendas",
};
